import React, { useState } from "react";
import HeroImage from "../../assets/img/portfolio/Shreya&Mitchel/Shreya&MitchelBigBanner.webp";

import gallery from "../../assets/img/bg/weiding-bg.webp";

const PurvaRaghav = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");

  // Define your image paths here
  const images = {
    portfolio1: require("../../assets/img/portfolio/Shreya&Mitchel/1.webp"),
    portfolio2: require("../../assets/img/portfolio/Shreya&Mitchel/2.webp"),
    portfolio3: require("../../assets/img/portfolio/Shreya&Mitchel/3.webp"),
    portfolio4: require("../../assets/img/portfolio/Shreya&Mitchel/4.webp"),
    portfolio5: require("../../assets/img/portfolio/Shreya&Mitchel/5.webp"),
    portfolio6: require("../../assets/img/portfolio/Shreya&Mitchel/6.webp"),
    portfolio7: require("../../assets/img/portfolio/Shreya&Mitchel/7.webp"),
    portfolio8: require("../../assets/img/portfolio/Shreya&Mitchel/8.webp"),
    portfolio9: require("../../assets/img/portfolio/Shreya&Mitchel/9.webp"),
    portfolio10: require("../../assets/img/portfolio/Shreya&Mitchel/10.webp"),
    portfolio11: require("../../assets/img/portfolio/Shreya&Mitchel/11.webp"),
    portfolio12: require("../../assets/img/portfolio/Shreya&Mitchel/12.webp"),
    portfolio13: require("../../assets/img/portfolio/Shreya&Mitchel/13.webp"),
    portfolio14: require("../../assets/img/portfolio/Shreya&Mitchel/14.webp"),
    portfolio15: require("../../assets/img/portfolio/Shreya&Mitchel/15.webp"),
    portfolio16: require("../../assets/img/portfolio/Shreya&Mitchel/16.webp"),
    portfolio17: require("../../assets/img/portfolio/Shreya&Mitchel/17.webp"),
    portfolio18: require("../../assets/img/portfolio/Shreya&Mitchel/18.webp"),
    portfolio19: require("../../assets/img/portfolio/Shreya&Mitchel/19.webp"),
    portfolio20: require("../../assets/img/portfolio/Shreya&Mitchel/20.webp"),
    portfolio21: require("../../assets/img/portfolio/Shreya&Mitchel/21.webp"),
    portfolio22: require("../../assets/img/portfolio/Shreya&Mitchel/22.webp"),
  };

  // Function to handle image click: opens the modal with the selected image
  const openModal = (imageKey) => {
    setSelectedImage(images[imageKey]);
    setIsModalOpen(true);
  };

  // Function to close the modal
  const closeModal = () => {
    setIsModalOpen(false);
  };

  const containerStyle = {
    background: `url(${HeroImage}) top/cover no-repeat`,
    backgroundColor: "#1C242970", // This sets a semi-transparent overlay color
    height: "60vh",
  };

  return (
    <div>
      <div
        style={containerStyle}
        className="flex  items-center justify-center relative -z-[900] "
      >
        <div className="absolute inset-0 bg-[#0000007f] z-0"></div>

        <h2 className="text-white text-center text-[60px] z-0">
          Shreya & Mitchel
        </h2>
      </div>

      <div class="flex flex-col lg:flex-row justify-center gap-10 lg:px-10 px-2 py-10">
        <div class="lg:w-[500px]">
          <div class="lv-portfolio-details-top-wrap-1-4 mb-35">
            <h4 class="lv-portfolio-details-title-1-4 text-[#000066]">
              Shreya & Mitchel
            </h4>

            <span class="lv-portfolio-date-1-4">
              January 2025, Kenilworth resort & spa, Goa
            </span>
          </div>
          <div class="lv-portfolio-details-content-1-4 mb-30">
            <h2>A Dutch-Bengali Love Story in the Heart of Goa</h2>
            <p class="mb-25">
              When Shreya & Mitchel entrusted us with their wedding, they wanted
              an experience that felt like a seamless blend of their Bengali and
              Dutch heritage. With Kenilworth Resort & Spa, Goa as their
              stunning venue, we curated an extraordinary two-day celebration,
              fusing vibrant traditions with modern elegance.
            </p>
            <h3>Day 1 – A Spirited Start with Haldi & Sangeet</h3>
            <p class="mb-25">
              The wedding festivities began at the Frangipani Lawns, where the
              Haldi ceremony was a bold burst of pinks, oranges, and terracotta
              tones, adorned with colorful windmills, terracotta pots, and
              draped cabanas. The space radiated joy as family and friends
              drenched the couple in turmeric and love. By nightfall, the energy
              shifted to the Sea View Lawns for the Sangeet, a night of music,
              dance, and celebration. We created a glamorous setting with black
              arches, fairy-lit pathways, and an LED-lit stage, where the
              highlight of the night was an electrifying performance by "SHOR
              POLICE," Clinton Cerejo, and Siddharth Mahadevan. The evening
              transitioned into a Silent Disco Party, keeping the excitement
              alive until 2 AM under the starlit Goan sky.
            </p>
            <h3>Day 2 – A Dreamy Sundowner Wedding & Heartfelt Reception</h3>
            <p class="mb-25">
              The couple exchanged vows at Sea Mist, where we crafted a
              breathtaking floral mandap with deep red and white blooms, baby’s
              breath, and a dramatic aisle leading to the altar. With the sunset
              painting the sky, the moment felt surreal as they embarked on
              their forever journey. As night fell, we transformed Aquatica into
              an intimate reception space. Warm candlelit tables, soft florals,
              and golden terrariums set a romantic tone for an evening filled
              with heartfelt speeches, laughter, and nostalgic memories. And, of
              course, the celebrations didn’t end there—The Pavilion hosted a
              high-energy After Party, with neon-lit décor, a shimmering DJ
              booth, and an atmosphere that kept guests dancing till the early
              hours.
            </p>
            <h3>A Wedding That Was Nothing Short of Magical</h3>
            <p class="mb-25">
              Shreya & Mitchel’s wedding was a beautiful fusion of tradition,
              culture, and pure joy. Every detail, from the smallest décor
              elements to the grandest performances, was designed to create an
              unforgettable experience—and we’re honored to have been a part of
              it.
            </p>
          </div>
        </div>

        <div className="lg:w-[600px]">
          {/* Mapping other images, assuming similar behavior for simplicity */}
          <div className="py-3">
            <img
              className=""
              src={require("../../assets/img/portfolio/Shreya&Mitchel/16.webp")}
            />
          </div>
          <div className="flex gap-3 flex-col lg:flex-row ">
            <div
              className="lg:w-[400px] h-[300px] bg-cover bg-center"
              style={{
                backgroundImage: `url(${images["portfolio1"]})`,
              }}
            ></div>
            <div
              className="lg:w-[400px] h-[300px] bg-cover bg-center"
              style={{
                backgroundImage: `url(${images["portfolio2"]})`,
              }}
            ></div>
          </div>
          <div className="flex gap-3 flex-col lg:flex-row  py-3">
            <div
              className="lg:w-[400px] h-[300px] bg-cover bg-center"
              style={{
                backgroundImage: `url(${images["portfolio3"]})`,
              }}
            ></div>
            <div
              className="lg:w-[400px] h-[300px] bg-cover bg-top-center"
              style={{
                backgroundImage: `url(${images["portfolio4"]})`,
              }}
            ></div>
          </div>
          <div className="flex gap-3 flex-col lg:flex-row  py-3">
            <div
              className="lg:w-[400px] h-[300px] bg-cover bg-center"
              style={{
                backgroundImage: `url(${images["portfolio5"]})`,
              }}
            ></div>
            <div
              className="lg:w-[400px] h-[300px] bg-cover bg-top-center"
              style={{
                backgroundImage: `url(${images["portfolio6"]})`,
              }}
            ></div>
          </div>
          <div className="flex gap-3 flex-col lg:flex-row  py-3">
            <div
              className="lg:w-[400px] h-[300px] bg-cover bg-center"
              style={{
                backgroundImage: `url(${images["portfolio7"]})`,
              }}
            ></div>
            <div
              className="lg:w-[400px] h-[300px] bg-cover bg-top-center"
              style={{
                backgroundImage: `url(${images["portfolio8"]})`,
              }}
            ></div>
          </div>
          <div className="flex gap-3 flex-col lg:flex-row  py-3">
            <div
              className="lg:w-[400px] h-[300px] bg-cover bg-no-repeat  bg-right-top"
              style={{
                backgroundImage: `url(${images["portfolio9"]})`,
              }}
            ></div>
            <div
              className="lg:w-[400px] h-[300px] bg-cover bg-center"
              style={{
                backgroundImage: `url(${images["portfolio10"]})`,
              }}
            ></div>
          </div>
          <div className="flex gap-3 flex-col lg:flex-row  py-3">
            <div
              className="lg:w-[400px] h-[300px] bg-cover bg-center"
              style={{
                backgroundImage: `url(${images["portfolio11"]})`,
              }}
            ></div>
            <div
              className="lg:w-[400px] h-[300px] bg-cover bg-top-center"
              style={{
                backgroundImage: `url(${images["portfolio12"]})`,
              }}
            ></div>
          </div>
          <div className="flex gap-3 flex-col lg:flex-row  py-3">
            <div
              className="lg:w-[400px] h-[300px] bg-cover bg-center"
              style={{
                backgroundImage: `url(${images["portfolio13"]})`,
              }}
            ></div>
            <div
              className="lg:w-[400px] h-[300px] bg-cover bg-center"
              style={{
                backgroundImage: `url(${images["portfolio14"]})`,
              }}
            ></div>
          </div>
          <div className="flex gap-3 flex-col lg:flex-row  py-3">
            <div
              className="lg:w-[400px] h-[300px] bg-cover bg-center"
              style={{
                backgroundImage: `url(${images["portfolio15"]})`,
              }}
            ></div>
            <div
              className="lg:w-[400px] h-[300px] bg-cover bg-top-center"
              style={{
                backgroundImage: `url(${images["portfolio16"]})`,
              }}
            ></div>
          </div>

          {/* Modal for displaying the clicked image */}
          {isModalOpen && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: "rgba(0, 0, 0, 0.8)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 1000,
              }}
              onClick={closeModal}
            >
              <img
                src={selectedImage}
                alt="Modal"
                style={{ maxWidth: "90%", maxHeight: "90%" }}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PurvaRaghav;
